import { logger } from 'src/helper';

export const removeWidthAndHeightFromRichTextImage = (html: string) => {
  if (html.trim() === '') return html;
  let htmlString = html;
  try {
    const fragment = document.createRange().createContextualFragment(html);
    const imgs = fragment.querySelectorAll('img');
    // 遍历富文本中的img标签，删除尺寸属性，防止内联样式无法被覆盖导致图片超出聊天框
    imgs.forEach((img) => {
      img.removeAttribute('width');
      img.removeAttribute('height');
    });
    const div = document.createElement('div');
    div.appendChild(fragment.cloneNode(true));
    htmlString = div.innerHTML;
  } catch (error) {
    logger.error(
      '[Utils-removeWidthAndHeightFromRichTextImage]',
      'error when removing width and height from rich text',
      error,
    );
  }
  return htmlString;
};
